import { Component, OnInit, HostListener } from '@angular/core';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { AppUtilityService } from '../common/app-utility.service';
import { environment } from "src/environments/environment.prod"


declare var $: any;

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss']
})
export class CompanyDetailsComponent implements OnInit {

  isForm: FormGroup
  isEditMode: boolean = false;
  UserMailingEditMode: boolean = false;
  bPostalCodeMaxLength = '5';
  bPostalCodeMinLength = '5';
  mPostalCodeMaxLength = '5';
  mPostalCodeMinLength = '5';


  constructor(
    private connect: ConnectRestService,
    private formBuilder: FormBuilder,
    public router: Router,
    public appComp: AppComponent,
    private activatedRoute: ActivatedRoute,
    private AppUtility: AppUtilityService) {
    //used to prevent back button --- added by Sonny
    sessionStorage.currentPage = window.location.href;
  }
  // (Begin) Added by CJT / Code by Sonny 09Jul2020
  //change request for SIR 9 and 14 --- start
  // find word 'onPaste="return false" onDrop="return false" onDrag="return false"' for relevant change in HTML
  @HostListener('document:keypress', ['$event'])
  onKeyPress(elemValue) {
    if (String(elemValue.target.id).startsWith("postcode")) {
      return this.AppUtility.numericOnlyValidation(elemValue.key)
    } else if (elemValue.target.type === 'text') {
      return this.AppUtility.characterValidation(elemValue.key)
    }
  }
  // (End) CJT / Sonny 09Jul2020

  CompanyDetails: FormGroup;
  RefCODL: any;
  RefBPDL: any;
  RefCCDL: any;
  RefSCDL: any;
  MailingHolder: any;
  StateHolder: any;
  // (Begin) CJT 11Jun2020 pull dropdown values

  async callDropdownValues() {
    this.RefCODL = JSON.parse(sessionStorage.RefCODL);
    this.RefBPDL = JSON.parse(sessionStorage.RefBPDL);
    this.RefCCDL = JSON.parse(sessionStorage.RefCCDL);
    this.RefSCDL = JSON.parse(sessionStorage.RefSCDL);
  }


  //(End) CJT 11Jun2020
  ngOnInit() {
    this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;
    this.buildForm();
    this.callDropdownValues().then(this.appComp.loadCustomDropdown);
    this.callReadRequest();


    /* DCI update (29 June 2020): Add function to change maxlength of postcode start*/
    $("#country_1").change(function () {
      if ($("#country_1").val() == "MY") {
        $("#postcode_1").attr("maxlength", 5);
        $("#postcode_1").attr("minlength", 5);
      } else {
        $("#postcode_1").attr("maxlength", 9);
        $("#postcode_1").attr("minlength", 1);
      }
      $("#obaoform").validate().element("#postcode_1");
    });

    $("#country_2").change(function () {
      if ($("#country_2").val() == "MY") {
        $("#postcode_2").attr("maxlength", 5);
        $("#postcode_2").attr("minlength", 5);
      } else {
        $("#postcode_2").attr("maxlength", 9);
        $("#postcode_2").attr("minlength", 1);
      }
      $("#obaoform").validate().element("#postcode_2");
    });
    /* DCI update (29 June 2020): Add function to change maxlength of postcode end*/


    $(".mailing_address").hide();
    $("#mailing_address_check").click(function () {
      if ($(this).is(":checked")) {
        $(".mailing_address").hide();
      } else {
        $(".mailing_address").show();
      }
    });

    /*   $(document).change(function () {
        $("#obaoform").valid();
       })
   */
    $(document).ready(function () {
      /*DCI update (17 June 2020) : Testing get value from dropdown start*/
      // $('#country_select').click(function(){
      //   var val = $("#country_1").val();
      //   console.log("Selected option value:" + val);
      //  })

      //  $('#state_select').click(function(){
      //   var val = $("#state_1").val();
      //   console.log("Selected option value:" + val);
      //  })
      //  $('#constitution_select').click(function(){
      //   var val = $("#constitution").val();
      //   console.log("Selected option value:" + val);
      //  })
      /*DCI update (17 June 2020) : Testing get value from dropdown end*/

      /*DCI update (22 June 2020) : Show and hide field base on country dropdown start*/
      $('#country_select').click(function () {
        var val = $("#country_1").val();
        // console.log("Selected option value:" + val);
      })

      $("#country_1").change(function () {
        if ($("#country_1").val() == "MY") {
          $("#business_address_4").addClass("hidden");
          $(".b-state").show();
        } else {
          $("#business_address_4").removeClass("hidden");
          $(".b-state").hide();
        }
      })

      $("#country_2").change(function () {
        if ($("#country_2").val() == "MY") {
          $("#mailing_address_4").addClass("hidden");
          $(".m-state").show();
        } else {
          $("#mailing_address_4").removeClass("hidden");
          $(".m-state").hide();
        }
      })
      //DCI update (15/7/2020): Disable keypress enter or other to navigate page
      $("form").bind("keypress", function (e) {
        if (e.keyCode == 13) {
          return false;
        }
      })

      // $.validator.setDefaults({
      //   ignore: ".ignore"
      // });

      // var validator =
       $("#obaoform").validate({

        rules: {
          business_name: {
            required: true
          },
          registration_name: {
            required: true
          },
          business_email: {
            required: true,
            email:true
          },
          constitution: {
            required: true,
          },
          business_address_1: {
            required: true
          },
          postcode_1: {
            required: true,
            number: true
          },
          state_1: {
            required: {
              depends: function () {
                if ($("#country_1").val() == "MY") {
                  return true;
                } else {
                  return false;
                }

              }
            }
          },
          country_1: {
            required: true
          },
          premise: {
            required: true
          },
          state_2: {
            required: {
              depends: function () {

                if ($("#country_2").val() == "MY") {
                  return true;
                } else {
                  return false;
                }

              }
            },
            
          },
          country_2: {
            required: true
          },
          mailing_address_1: {
            required: true
          },
          postcode_2: {
            required: true,
            number: true

          },
        },
        messages: {
          business_name: {
            required: "Please enter business name"
          },
          registration_name: {
            required: "Please enter registration number"
          },
          business_email: {
            required: "Please enter business email",
            email: "Please enter valid email address"
          },
          constitution: {
            required: "Please select constitution"
          },
          business_address_1: {
            required: "Please enter your business address",
          },
          postcode_1: {
            required: "Please enter postcode",
            number: "Postcode should be numeric",
            maxlength: "Postcode should be no more than {0} numeric characters.",
            minlength: "Please enter at least {0} numeric characters."
          },
          state_1: {
            required: "Please select state"
          },
          country_1: {
            required: "Please select country"
          },
          premise: {
            required: "Please select premise"
          },
          state_2: {
            required: "Please select state"
          },
          country_2: {
            required: "Please select country"
          },
          mailing_address_1: {
            required: "Please enter your mailing address",
          },
          postcode_2: {
            required: "Please enter postcode",
            number: "Postcode should be numeric",
            maxlength: "Postcode should be no more than {0} numeric characters.",
            minlength: "Please enter at least {0} numeric characters."
          },



        },
        // (Begin) CJT 25Jun2020 to display error message when user skipped the field
        onfocusout: function (element) {
          $(element).valid();
        },
        // (End) CJT 25Jun2020

        errorPlacement: function (error, element) {

          if (element.attr("name") == "business_name") {
            error.appendTo($("#business_name_error_container"));
          }

          if (element.attr("name") == "registration_name") {
            error.appendTo($("#registration_name_error_container"));
          }

          if (element.attr("name") == "business_email") {
            error.appendTo($("#business_email_error_container"));
          }

          if (element.attr("name") == "constitution") {
            error.appendTo($("#constitution_error_container"));
          }

          if (element.attr("name") == "business_address_1") {
            error.appendTo($("#business_address_1_error_container"));
          }

          if (element.attr("name") == "postcode_1") {
            error.appendTo($("#postcode_1_error_container"));
          }

          if (element.attr("name") == "constitution") {
            error.appendTo($("#constitution_error_container"));
          }
          if (element.attr("name") == "state_1") {
            error.appendTo($("#state_1_error_container"));
          }
          if (element.attr("name") == "country_1") {
            error.appendTo($("#country_1_error_container"));
          }
          if (element.attr("name") == "premise") {
            error.appendTo($("#premise_error_container"));
          }
          if (element.attr("name") == "state_2") {
            error.appendTo($("#state_2_error_container"));
          }
          if (element.attr("name") == "country_2") {
            error.appendTo($("#country_2_error_container"));
          }

          if (element.attr("name") == "mailing_address_1") {
            error.appendTo($("#mailing_address_1_error_container"));
          }

          if (element.attr("name") == "postcode_2") {
            error.appendTo($("#postcode_2_error_container"));
          }
        },
        submitHandler: function (form) {
          // $("#btn-next").prop("disabled", true);
        }
      });
    })
  }

  onSubmit() {
    //if ($("#obaoform").valid()) {
    // (Begin) CJT 05Jun2020 - Send S0010 Service and Redirect to Director Details Screen upon clicking Next Button

    // (Begin Branch 1) CJT 09Jun2020 - Added a condition that if the mailing is ticked, it will copy the value from business address
    if (this.CompanyDetails.value.isMailingTicked) {
      this.copyBusinessAddress();
      // console.log("Business Address is copied to Mailing Address.");
    }
    // (End Branch 1) CJT 09Jun2020
    this.callSaveRequest();
    // (End) CJT 05Jun2020 
    //}
  }


  // (Begin) CJT 5Jun2020 to call connectRest Service Function
  async restConnect(data, reqID) {
    this.connect.consoleLog("data value", data)
    var ServResponse = await this.connect.connectRest(data, reqID, '');
    return ServResponse;
  }
  // (End) CJT 05Jun2020


  // (Begin) CJT 05Jun2020 - Add the FormGroup
  buildForm() {
    this.CompanyDetails = this.formBuilder.group(
      {
        business_name: ['', Validators.required],
        premise: ['', Validators.required],
        registration_name: ['', Validators.required],
        business_email: ['', [Validators.required, Validators.pattern(environment.emailPattern)]],
        constitution: ['', Validators.required],
        business_address_1: ['', Validators.required],
        business_address_2: [''],
        business_address_3: [''],
        business_address_4: [''],
        country_1: ['', Validators.required],
        postcode_1: ['', Validators.required],
        state_1: ['', Validators.required],
        isMailingTicked: [true],
        mailing_address_1: [''],
        mailing_address_2: [''],
        mailing_address_3: [''],
        mailing_address_4: [''],
        country_2: [''],
        postcode_2: [''],
        state_2: ['']
      }
    )
  }
  // (End) CJT 05Jun2020 


  // DCI updata(17 Jun 2020) : add async as the function call and declare const equal to await
  // async runDataDropdown() {
  // const build = await this.buildForm();
  // const callDropdownthis = await this.callDropdownValues();
  // const read = await this.callReadRequest();
  // const callStyle = await this.appComp.loadCustomDropdown();
  // }

  async callSaveRequest() {
    var locStorage=JSON.parse(localStorage.getItem("URLParam"))
    sessionStorage.CompanyType = this.CompanyDetails.value.constitution;
    var data = {
      CompanyInfo: {
        AddressInfo: [{
          AddressType: "B", // Business
          AddressLine1: this.CompanyDetails.value.business_address_1,
          AddressLine2: this.CompanyDetails.value.business_address_2,
          AddressLine3: this.CompanyDetails.value.business_address_3,
          AddressLine4: this.CompanyDetails.value.business_address_4,
          CountryCode: this.CompanyDetails.value.country_1,
          PostalCode: this.CompanyDetails.value.postcode_1,
          StateCode: this.CompanyDetails.value.state_1
        }, {
          AddressType: "M", // Mailing
          AddressLine1: this.CompanyDetails.value.mailing_address_1,
          AddressLine2: this.CompanyDetails.value.mailing_address_2,
          AddressLine3: this.CompanyDetails.value.mailing_address_3,
          AddressLine4: this.CompanyDetails.value.mailing_address_4,
          CountryCode: this.CompanyDetails.value.country_2,
          PostalCode: this.CompanyDetails.value.postcode_2,
          StateCode: this.CompanyDetails.value.state_2
        }],
        BusinessName: this.CompanyDetails.value.business_name,
        BusinessPremisesCode: this.CompanyDetails.value.premise,
        CompanyTypeCode: this.CompanyDetails.value.constitution,
        ContactInfo: [
          {
            Type: "EM", //Email
            Value: this.CompanyDetails.value.business_email,
          }
        ],
        UEN: this.CompanyDetails.value.registration_name
      },
      AccountDetails: [
        {
          ProductCode:locStorage.Product, //change this
          ProductDescription: locStorage.ProductDescription //change this
        }
      ],
      Source1:locStorage.Source1,
      Source2:locStorage.Source2,

    }
    sessionStorage.setItem('constitution', this.CompanyDetails.value.constitution);
    var ServResponse = await this.restConnect(data, "S0010");
    if (ServResponse.Status == "Success") {
      if (!this.isEditMode) {
        this.router.navigate(['/director-details']);
      } else {
        this.router.navigate(['/director-confirm']);
      }
    }
    else {
      //  console.log("Server Response: " + ServResponse.Status);
    }
  }

  async callReadRequest() {
    // (Begin) CJT 09Jun2020 to call Request R0010
    let caseID = JSON.parse(sessionStorage.getItem('ServiceHeader')).CaseID;
    if (caseID) {
      // console.log("Case ID found. Pre-populating values...");
      var data = {};
      var ServResponse = await this.restConnect(data, "R0010");
      if (ServResponse.Status == "Success") {
        this.setDataResponse(ServResponse);
      }
      else {
        //  console.log("Server Response: " + ServResponse.Status);
      }

      // Added for Edit Mode
      if (this.isEditMode) {
        $("#registration_name").prop('disabled', true);
        $("#constitution").prop('disabled', true);
      }

      // (End) CJT 09Jun2020
    } else {
      this.CompanyDetails.patchValue(
        {
          country_1: environment.countryCode,
          country_2: environment.countryCode,
          state_1: environment.stateCode,
          state_2: environment.stateCode
        }
      )
      this.CompanyDetails.updateValueAndValidity();
    }

  }
  setDataResponse(data) {
    this.CompanyDetails.patchValue(
      {
        business_name: data.CompanyInfo.BusinessName,
        premise: data.CompanyInfo.BusinessPremisesCode,
        registration_name: data.CompanyInfo.UEN,
        business_email: data.CompanyInfo.ContactInfo[0].Value,
        constitution: data.CompanyInfo.CompanyTypeCode,
        business_address_1: data.CompanyInfo.AddressInfo[0].AddressLine1,
        business_address_2: data.CompanyInfo.AddressInfo[0].AddressLine2,
        business_address_3: data.CompanyInfo.AddressInfo[0].AddressLine3,
        business_address_4: data.CompanyInfo.AddressInfo[0].AddressLine4,
        country_1: data.CompanyInfo.AddressInfo[0].CountryCode,
        postcode_1: data.CompanyInfo.AddressInfo[0].PostalCode,
        state_1: data.CompanyInfo.AddressInfo[0].StateCode,
        mailing_address_1: data.CompanyInfo.AddressInfo[1].AddressLine1,
        mailing_address_2: data.CompanyInfo.AddressInfo[1].AddressLine2,
        mailing_address_3: data.CompanyInfo.AddressInfo[1].AddressLine3,
        mailing_address_4: data.CompanyInfo.AddressInfo[1].AddressLine4,
        country_2: data.CompanyInfo.AddressInfo[1].CountryCode,
        postcode_2: data.CompanyInfo.AddressInfo[1].PostalCode,
        state_2: data.CompanyInfo.AddressInfo[1].StateCode
      }
    )
    this.CompanyDetails.updateValueAndValidity();
    //Show/Hide Business State based on Country Selected On Load
    if (this.CompanyDetails.value.country_1 == "MY") {
      $("#business_address_4").addClass("hidden");
      $(".b-state").show();
    } else {
      $("#business_address_4").removeClass("hidden");
      $(".b-state").hide();
      this.bPostalCodeMaxLength = '9';
      this.bPostalCodeMinLength = '1';
    }

    // (Begin) Added by CJT 03Jul2020 for removing the error in validation for "required" field in hidden state 
    $("#obaoform").validate();
    // (End) CJT 03Jul2020

    // compare mailing and business address because of check box 
    if ((this.CompanyDetails.value.mailing_address_1 == this.CompanyDetails.value.business_address_1)
      && (this.CompanyDetails.value.mailing_address_2 == this.CompanyDetails.value.business_address_2)
      && (this.CompanyDetails.value.mailing_address_3 == this.CompanyDetails.value.business_address_3)
      && (this.CompanyDetails.value.mailing_address_4 == this.CompanyDetails.value.business_address_4)
      && (this.CompanyDetails.value.country_2 == this.CompanyDetails.value.country_1)
      && (this.CompanyDetails.value.postcode_2 == this.CompanyDetails.value.postcode_1)
      && (this.CompanyDetails.value.state_2 == this.CompanyDetails.value.state_1)
    ) {
      //Mailing Address is Hidden
      this.CompanyDetails.patchValue({
        isMailingTicked: true
      });

      // Hidden Fields was validated by length 07Jul2020
      this.mPostalCodeMaxLength = '9';
      this.mPostalCodeMinLength = '0';

    } else {
      //Mailing Address Is Shown
      this.CompanyDetails.patchValue({
        isMailingTicked: false
      });

      $(".mailing_address").show();
      //Show/Hide Business State based on Country Selected On Load
      if (this.CompanyDetails.value.country_2 == "MY") {
        $("#mailing_address_4").addClass("hidden");
        $(".m-state").show();
      } else {
        $("#mailing_address_4").removeClass("hidden");
        $(".m-state").hide();
        this.mPostalCodeMaxLength = '9';
        this.mPostalCodeMinLength = '1';
      }
      //Add Mailing Address validators
      this.setMailingValidators();
      this.validateState("M");
    }

    //Validate the Business State
    this.validateState("B");

    this.CompanyDetails.updateValueAndValidity();
    // for initialization
    this.UserMailingEditMode = false;
  }


  // (Begin) CJT 24Jun2020 - For removing address line 4 / state value when country is toggled from MY to Non-MY and vice-versa

  // on Change of Business Address Country
  onBCountryChange() {
    //Validate the Business State
    this.validateState("B");
  }
  // on Change of Mailing Address Country
  onMCountryChange() {
    this.setUserEditMode();

    //Validate the Mailing State
    this.validateState("M");

  }
  // (End) CJT 24Jun2020

  setMailingValidators() {
    // Change the Validators based on the tick
    // copy on internal variable in case it is not empty
    this.MailingHolder = {
      mailing_address_1: this.CompanyDetails.value.mailing_address_1,
      mailing_address_2: this.CompanyDetails.value.mailing_address_2,
      mailing_address_3: this.CompanyDetails.value.mailing_address_3,
      mailing_address_4: this.CompanyDetails.value.mailing_address_4,
      country_2: this.CompanyDetails.value.country_2,
      postcode_2: this.CompanyDetails.value.postcode_2,
      state_2: this.CompanyDetails.value.state_2
    }

    if (this.CompanyDetails.value.isMailingTicked) {
      this.CompanyDetails.controls["mailing_address_1"].clearValidators();
      this.CompanyDetails.controls["country_2"].clearValidators();
      this.CompanyDetails.controls["postcode_2"].clearValidators();
    } else {
      this.CompanyDetails.controls["mailing_address_1"].setValidators([Validators.required]);
      this.CompanyDetails.controls["country_2"].setValidators([Validators.required]);
      this.CompanyDetails.controls["postcode_2"].setValidators([Validators.required]);
    }

    //Put back the copied values to variable back to formcontrol
    this.CompanyDetails.patchValue({
      mailing_address_1: this.MailingHolder.mailing_address_1,
      mailing_address_2: this.MailingHolder.mailing_address_2,
      mailing_address_3: this.MailingHolder.mailing_address_3,
      mailing_address_4: this.MailingHolder.mailing_address_4,
      country_2: this.MailingHolder.country_2,
      postcode_2: this.MailingHolder.postcode_2,
      state_2: this.MailingHolder.state_2
    });

    this.CompanyDetails.updateValueAndValidity();
  }
  setMailingAddress() {
    // (Begin) CJT 08Jun2020 - For ticking the mailing address check box
    this.setMailingValidators();
    if (!this.CompanyDetails.value.isMailingTicked) {
      // Only copy if the User did not edit the Mailing Values -- this.UserMailingEditMode is the variable to determine if the User Edited the Mailing Address
      if (this.UserMailingEditMode == false) {
        this.copyBusinessAddress();
        //  console.log("Mailing is same as Business by default.")
      } else {
        this.CompanyDetails.patchValue({
          mailing_address_1: this.MailingHolder.mailing_address_1,
          mailing_address_2: this.MailingHolder.mailing_address_2,
          mailing_address_3: this.MailingHolder.mailing_address_3,
          mailing_address_4: this.MailingHolder.mailing_address_4,
          country_2: this.MailingHolder.country_2,
          postcode_2: this.MailingHolder.postcode_2,
          state_2: this.MailingHolder.state_2
        });
      }
    }
    this.validateState("M");
    this.CompanyDetails.updateValueAndValidity();
    // (END) CJT 08Jun2020
  }

  // Used on Mailing Address Fields - to ensure the tick won't restore business address if user changed the values
  setUserEditMode() {
    this.UserMailingEditMode = true;
    //This value will never go back to false unless page is re-initialized.
    // console.log("User is editing the Mailing Address.")
  }

  copyBusinessAddress() {
    var countrySelected = $("#country_1").val();
    var stateSelected = $("#state_1").val();
    if (stateSelected == null) { stateSelected = ''; }
    $("#country_2").val(countrySelected);
    $("#state_2").val(stateSelected);

    //This sets the value visibly on the UI
    if ($("#country_2").val() == "MY") {
      $("#mailing_address_4").addClass("hidden");
      $(".m-state").show();
    } else {
      $("#mailing_address_4").removeClass("hidden");
      $(".m-state").hide();
    }
    //This sets the value on the FormControl
    this.CompanyDetails.patchValue({
      mailing_address_1: this.CompanyDetails.value.business_address_1,
      mailing_address_2: this.CompanyDetails.value.business_address_2,
      mailing_address_3: this.CompanyDetails.value.business_address_3,
      mailing_address_4: this.CompanyDetails.value.business_address_4,
      state_2: stateSelected,
      country_2: countrySelected,
      postcode_2: this.CompanyDetails.value.postcode_1
    });

    this.CompanyDetails.updateValueAndValidity();
  }
  // (Begin) CJT 24Jun2020 Added Validator for State on Change of MY to Non-MY
  validateState(addressType: string) {

    if (addressType == "B") {
      var state1 = '';
      if ($("#country_1").val() == "MY") {
        state1 = this.CompanyDetails.value.state_1;
        this.CompanyDetails.controls["state_1"].setValidators([Validators.required]);
        this.CompanyDetails.patchValue({
          business_address_4: '',
          state_1: state1
        });
        $("#state_1").rules('add', { required: true });
        this.bPostalCodeMaxLength = '5';
        this.bPostalCodeMinLength = '5';

      } else {
        this.CompanyDetails.controls["state_1"].clearValidators();
        this.CompanyDetails.patchValue({
          state_1: state1
        });
        $("#state_1").val('');
        $("#state_1").rules('remove', 'required');
        this.bPostalCodeMaxLength = '9';
        this.bPostalCodeMinLength = '1';
      }

      $("#state_1").valid();
    } else {
      var state2 = '';
      if ($("#country_2").val() == "MY" && !this.CompanyDetails.value.isMailingTicked) {
        state2 = this.CompanyDetails.value.state_2;
        this.CompanyDetails.controls["state_2"].setValidators([Validators.required]);
        this.CompanyDetails.patchValue({
          mailing_address_4: '',
          state_2: state2
        });
        $("#state_2").rules('add', { required: true });
        this.mPostalCodeMaxLength = '5';
        this.mPostalCodeMinLength = '5';

      } else {
        this.CompanyDetails.controls["state_2"].clearValidators();
        this.CompanyDetails.patchValue({
          state_2: state2
        });
        $("#state_2").val('');
        $("#state_2").rules('remove', 'required');
        this.mPostalCodeMaxLength = '9';
        this.mPostalCodeMinLength = '1';
      }

      $("#state_2").valid();
    }

    this.CompanyDetails.updateValueAndValidity();
  }
  // (End) CJT 24Jun2020
  validateChar(event){
    var value = event.target.value;
    var control = event.target.getAttribute('formcontrolname');
    if(!this.AppUtility.stringValidation(value)){
      this.CompanyDetails.get(control).setValue(this.AppUtility.filterInvalidCharacters(value));
    }
  }

}
